<template>
  <section v-editable="blok" class="home-global">
    <div class="container">
      <div class="home-global__content">
        <StoryblokComponent
          v-for="childBlok in blok.content"
          :key="childBlok._uid"
          :blok="childBlok"
        />
      </div>
      <NuxtImg
        sizes="sm:400px md:600px lg:900px"
        src="https://a.storyblok.com/f/120667/1818x1064/4389257bdd/globe-desktop.png"
        provider="storyblok"
        width="900"
        format="webp"
        alt="Global Reach"
        loading="lazy"
        class="home-global__image"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { SbHomepageGlobalReach } from '@/types'

interface Props {
  blok: SbHomepageGlobalReach
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.home-global {
  overflow: hidden;
  padding: 96px 0 300px 0;
  background-color: var(--cobalt-800);

  @media (min-width: $breakpoint-lg) {
    padding: 128px 0;
  }

  &__content {
    position: relative;
    z-index: 2;
  }

  &__image {
    position: absolute;
    bottom: -300px;
    width: 600px;
    right: -200px;

    @media (min-width: $breakpoint-md) {
      bottom: -330px;
      right: -186px;
      width: 700px;
    }

    @media (min-width: $breakpoint-lg) {
      bottom: -128px;
      left: 634px;
      max-width: 900px;
      width: 100%;
    }
  }
}
</style>
